<template>
    <div class="shatter-stacked-bar-chart">
        <app-sub-title v-if="!!title" :text="title" />
        <div class="shatter-pie-chart__pie">
            <GChart 
                type="ColumnChart"
                :data="chartData"
                :options="chartOptions"
            />
        </div>
    </div>
</template>
<script>
import { GChart } from 'vue-google-charts';
export default {
    components: {
        GChart
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        chartData: {
            type: Array,
            default: []
        }
    },
    data(){
        return {
            chartOptions: {
                width: 500,
                height: 300,
                legend: {
                    position: 'right',
                    alignment: 'center'
                },
                isStacked: true
            },
            tableOptions: {
                sort: true
            }
        }
    },
    computed: {
        tableData(){
            if(!this.chartData.length) return [];
            const header = this.chartData[0].concat('Indicador');
            const tableData = [header];
            let total = 0;
            this.chartData.map((row, index) => {
                if(index === 0) return;
                total = total + row[1];
            });
            let indicator = 0;
            for(let i = 1; i < this.chartData.length; i++){
                indicator = _.round(this.chartData[i][1] / total * 100, 1);
                tableData.push(this.chartData[i].concat({
                    v: indicator,
                    f: `${indicator}%`
                }));
            }
            tableData.push([
                'Total',
                {
                    v: total,
                    f: total
                },
                {
                    v: 100,
                    f: '100%'
                }
            ])
            return tableData;
        }
    }
}
</script>
<style scoped>
    .shatter-stacked-bar-chart {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>